import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingFeeCondition')
export class PricingFeeCondition extends AbstractModel {
  @JsonProperty(Number, 'min')
  min?: number

  @JsonProperty(Number, 'max')
  max?: number

  @JsonProperty(Number, 'value')
  value?: number
}

